import React from "react";
import PropTypes from "prop-types";
import * as types from "./ParentObjectTypes/index.jsx";

export const ParentObjectConversation = ({ parentType, parentId, conversationId }) => {
  const ParentObject = types[parentType];

  return ParentObject ? (
    <ParentObject
      id={parentId}
      conversationId={conversationId}
    />
  ) : null;
};

ParentObjectConversation.propTypes = {
  parentId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  conversationId: PropTypes.number.isRequired,
};
